// Imports
import React from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { Provider, useDispatch } from 'react-redux';
import { ThemeProvider } from '@arredo/reactjs-ui';

// Material UI
import { CssBaseline } from '@mui/material';

// Date pickers
import { LocalizationProvider } from '@mui/x-date-pickers';
import dayjs from 'dayjs';
import 'dayjs/locale/es';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';

// Components
import store from "./stores";
import Layout from './components/layout';
import Router from './router';
import evnConfig from './config';

// Hooks
import { LoginProvider, LoginStorage } from '@arredo/reactjs-ui';
import NotificationProvider from './hooks/notify/NotificationProvider';

import './i18n';
import { loginUser, selectBranch } from './stores/mainStore/actions';
dayjs.locale('es');
// App Component

const App = () => {
  const dispatch = useDispatch();
  return (
    <ThemeProvider>
      <CssBaseline />
      <LocalizationProvider dateAdapter={AdapterDayjs} adapterLocale="es">
        <NotificationProvider maxSnack={3}>
          <LoginProvider
            baseUrl={evnConfig.apiGateway.URL?.replace(/\/$/, '')}
            onAuthenticated={(user) => dispatch(loginUser(user))}
            onRestored={(user) => {
              const { business, branch, pv, cashRegister } = LoginStorage.getData();
              dispatch(loginUser(user));
              dispatch(selectBranch(business, branch, pv, cashRegister));
            }}
          >
            <Layout>
              <Router />
            </Layout>
          </LoginProvider>
        </NotificationProvider>
      </LocalizationProvider>
    </ThemeProvider>
  );
};

// Render
createRoot(document.getElementById('root')).render(
  <Provider store={store}>
    <BrowserRouter>
      <App />
    </BrowserRouter>
  </Provider>
);
